<template>
  <b-modal
      v-model="modalOpen"
      v-if="modalOpen"
      centered
      :title="mainTitle"
      size="xl"
      footer-class="removed"
      class="edit-modal"
      id="activityModal"
      no-close-on-backdrop
  >
    <b-card-text>
      <validation-observer ref="activityValidation">

        <b-form @submit.prevent="saveActivity">
          <b-row>
            <b-col cols="3">
              <form-select
                label="رقم و تاريخ اجتماع مجلس الإدارة"
                v-model="form.meeting_minute_id"
                :getOptionLabel="(x) => x.meeting_minutes_label"
                :reduce="(x) => x"
                id="gov"
                ep="v2/selects/meeting-minutes"
                ref="gov"
                rules="required"
              />
              
              <small class="text-secondary mb-1 d-block" style="margin-top: -10px;">
                في حال عدم وجود محضر الاجتماع يُرجى تقديم معاملة بالمحضر الجديد
              </small>
            </b-col>
            <b-col cols="3">
              <label for="year"> سنة الخطة </label>

              <form-mask
                id="year"
                options="blockNomber4"
                placeholder="YYYY"
                style="height: 37.5px !important"
                v-model="form.year"
                class="w-25"
              />
            </b-col>
          </b-row>
          <b-row>

            <b-col cols="12" class="my-2">
                معلومات الأنشطة :
            </b-col>
          </b-row>
            <div v-for="(item , i ) in form.data" :key="i" >
              <ActivityFormModal
                :item = "item"
                :i = "i"
                @i="onClickedDelete"
              />
            </div>
            <b-row>
              <b-col cols="12">
                <small class="text-danger d-flex align-items-end justify-content-end" v-if="isDuplicated"> يجب أن تكون الأنشطة التابعة للبرنامج ذاته مختلفة </small>
                
              </b-col>
            </b-row>
          <b-row>
            <b-col cols="12">
              <b-button
                  variant="success"
                  @click="onClickedAdd"
              >
                <feather-icon icon="PlusIcon" />
                إضافة
              </b-button>
            </b-col>
          </b-row>

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
                type="submit"
                variant="primary"
                :loading="loading"
                :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-text>
  </b-modal>
</template>

<script>
import { required } from "@validations";
import { ValidationObserver } from "vee-validate";

import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BFormCheckbox,
  BFormCheckboxGroup,
  BButton,
} from "bootstrap-vue";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
import ActivityFormModal from "@/modules/ngo/transactions/components/Add/ActivityFormModal.vue";
import FormMask from "@/components/form-mask";
const initForm = {
  activity_id: null,
  funds: null,
  beneficiaries_number: null,
  months: [],
};

export default {
  components: {
    ActivityFormModal,
    ValidationObserver,
    formInput,
    formSelect,
    BButton,
    formDatepicker,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
    BFormCheckbox,
    BFormCheckboxGroup,
    FormMask
  },
  props: {
    value: Boolean,
    mainTitle: { type: String, default: () => "تفاصيل النشاط" },
    btnLabel: { type: String, default: () => "حفظ" },
    loading: Boolean,
    activityName: {
      type: String,
      default: () => null,
    },
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      program_id: null,
      ep: null,
      selected: [],
      isDuplicated : false,
      options: [
        { text: "ك 2", value: "1" },
        { text: "شباط", value: "2" },
        { text: "آذار", value: "3" },
        { text: "نيسان", value: "4" },
        { text: "أيار", value: "5" },
        { text: "حزيران", value: "6" },
        { text: "تموز", value: "7" },
        { text: "آب", value: "8" },
        { text: "أيلول", value: "9" },
        { text: "ت 1", value: "10" },
        { text: "ت 2", value: "11" },
        { text: "ك 1", value: "12" },
      ],
      required,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen() {
      this.init(this.intializeForm);
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    saveActivity() {
      
      let activity_ids = [];
      this.$refs.activityValidation.validate().then((success) => {
        if (success) {
          this.form.data.forEach(obj => {
            let id = obj.activity_id.id;
            activity_ids.push(id)
          });
          this.isDuplicated = new Set(activity_ids).size !== activity_ids.length
          if(!this.isDuplicated){

            this.$emit("confirm", this.form);
          }
        }
      });
    },
    onClickedAdd(){
      if(!this.form.hasOwnProperty('data') || Object.keys(this.form.data).length === 0 ){
        this.form.data =[{}]
      }
      else{
        // check if any form station => open without save Data
        let i=0
        if(this.form.data.length === 0)
        {
          this.form.data.push({})
        }
        else{
          for(let item of this.form.data)
          {
            i +=1
            if(Object.keys(item).length === 0)
            {
              this.form.data.splice(i-1, 1)
            }
          }
          this.form.data.push({})
        }
      }
    },
    onClickedDelete(i){
      this.form.data.splice(i, 1)
    },
  },
};
</script>

<style lang="scss">
.checkbox-cont {
  .bv-no-focus-ring {
    display: grid;
    grid-template-columns: auto auto auto auto;
  }
}
</style>
